var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCurrentLocationWithHeading(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    clipRule: "evenodd",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    viewBox: "0 0 50 50",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.3968 0 0 1.3968 -17.765 -27.165)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.1932 0 0 2.8616 16.255 16.229)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m12.036 1.125 5.7 6.107h-11.4l5.7-6.107z",
    fill: "#f4f3f3"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2.3865e-5 2.3865e-5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.64304 0 0 .64304 10.04 20.306)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m32 11.5c-8.229 0-15 6.771-15 15s6.771 15 15 15 15-6.771 15-15-6.771-15-15-15zm0 26c-6.034 0-11-4.966-11-11s4.966-11 11-11 11 4.966 11 11-4.966 11-11 11z",
    fill: "#f4f3f3",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.74016 0 0 .74016 18.473 26.143)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16.407,
    cy: 15.137,
    r: 9.673,
    fill: "#006aff"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.1932 0 0 2.6084 16.255 16.514)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m12.036 1.125 2.72 6.107h-5.439l2.719-6.107z",
    fill: "#006aff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrentLocationWithHeading);
export default __webpack_public_path__ + "static/media/CurrentLocationWithHeading.5545bafdfcc24e4507fdf1204d3ba605.svg";
export { ForwardRef as ReactComponent };